import WebApp from "@twa-dev/sdk";

const BOT =
  (import.meta.env.VITE_TELEGRAM_BOT_USERNAME as string | undefined)?.trim().replace(/^@/, "") ||
  "";
const APP =
  (import.meta.env.VITE_TELEGRAM_MINI_APP as string | undefined)?.trim() || "";

/** Deep link into the Mini App when known. */
export function telegramAppLink(): string | null {
  if (!BOT) return null;
  if (APP) return `https://t.me/${BOT}/${APP}`;
  return `https://t.me/${BOT}`;
}

/**
 * True only inside a real Telegram Mini App session (non-empty initData).
 * Localhost is allowed for development unless VITE_FORCE_TMA_ONLY=1.
 */
export function isTelegramMiniApp(): boolean {
  const host = window.location.hostname.toLowerCase();
  const isLocal = host === "localhost" || host === "127.0.0.1";
  if (isLocal && import.meta.env.VITE_FORCE_TMA_ONLY !== "1") {
    return true;
  }

  try {
    const initData = (WebApp.initData || "").trim();
    if (initData.length > 0) return true;

    // Fallback: Telegram injects hash params before SDK hydrates
    const hash = window.location.hash || "";
    const search = window.location.search || "";
    if (/tgWebAppData=/i.test(hash) || /tgWebAppData=/i.test(search)) {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
